import React, { Component } from 'react';

import {SystemSettingsList} from './SystemSettingsList';
import SystemSettingsEdit from './SystemSettingsEdit';
import SystemSettingsIcon from "./SystemSettingsIcon";
import en_messages from './en_messages';
import SettingsIcon from "@material-ui/icons/Settings";


export const messages = {
    en: en_messages
}

export default ({
    RESOURCE: 'cloudsettings',
    TITLE: 'System',
    LIST: SystemSettingsList,
    LISTAUTH: 'cloudadmin',
    SHOW: null,
    EDIT: SystemSettingsEdit,
    EDITAUTH: 'cloudadmin',
    ICON: (<SystemSettingsIcon/>),
    messages: messages,
    parentMenu: 'admin',
    parentMenuIcon: (<SettingsIcon/>),
    disabled: false,
    menuHidden: false,
    menuAuth: 'cloudadmin'
});


